///
/// EarthBrowser
///
/// Created by Matt Giger on 2/2/2025
/// Copyright (c) 2025 Geodata Labs
///

export function NoscriptWarning() {
	return (
		<noscript>
			<div className='flex flex-col items-center justify-center h-screen'>
				<p className='text-center text-foreground'>Your browser does not support JavaScript or it is disabled.
					<br/>Please enable JavaScript to view this website properly.</p>
			</div>
		</noscript>
	)
}
